"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import Back from "../common/Back";
import BannerCarousel from "./BannerCarousel";

const Banner = ({ country }: { country: CountryInfo }) => {
  const countryDisplayName =
    country?.countryName === "United States"
      ? "United States Of America"
      : country?.countryName || "Abroad";

  return (
    <div className="relative">
      <span className="absolute left-5 sm:left-10 top-[20px] sm:top-[30px] z-20">
        <Back />
      </span>
      <div
        className="relative w-full py-12 sm:py-16 lg:py-20 flex items-center justify-center overflow-hidden"
        style={{
          background: `linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(102, 102, 102, 0) 100%), linear-gradient(270deg, #021935 -0.76%, #021935 75.38%)`,
        }}
      >
        <div className="container 2xl:max-w-[1628px] px-4 sm:px-6 flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-8">
          {/* Left Title & Button section */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left z-10 max-w-[580px]">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white ff_poppins leading-[1.15] mb-6">
              Study in {countryDisplayName}
            </h1>

            <button
              onClick={() => {
                const element = document.getElementById("universities");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                } else {
                  window.scrollTo({ top: 600, behavior: "smooth" });
                }
              }}
              className="px-8 py-3.5 rounded-full bg-gradient-to-r from-[#2b7fff] to-[#9b51e0] text-white font-semibold text-sm sm:text-base ff_poppins shadow-lg hover:shadow-blue-500/25 hover:scale-[102%] transition-all cursor-pointer active:scale-95"
            >
              View Universities
            </button>
          </div>

          {/* Right Stacked Auto-Slider */}
          <BannerCarousel
            slides={country.slides}
            galleryImages={country.galleryImages}
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
